export default "__VITE_ASSET__DCk8choh__"